export default "__VITE_ASSET__C5FNT1wS__"